import { createTheme } from '@mui/material';

// Freedom Power Brand Colors (matches fsp-marketing-dash)
export const BRAND = {
  freedomBlue: '#252F38',
  freedomOrange: '#F98A3C',
};

// Dark theme used across the board — import this, don't roll your own.
export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#0d0d1a',
      paper: '#1a1a2e',
    },
    primary: {
      main: BRAND.freedomOrange,
    },
    secondary: {
      main: BRAND.freedomBlue,
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  },
});
